import axios from "axios";
import { $userInfoBd } from "../store/user";
import { defaultPath } from "./defaultPath";
import { Item } from "../types/Item";

const cashToy:{[url: string]: Item} = {}

export const toys = {
    getSingle: async (id:string): Promise<Item> => {
        const user_id = $userInfoBd.getState()?.id;
        const url = `${defaultPath}toys/${id}?user_id=${user_id}`;

        if (cashToy[url]) {
            return cashToy[url];
        }

        const res = await axios.get(url);

        cashToy[url] = res.data;

        return res.data;
    },
    addToCollection: async (code_id:string) => {
        const user_id = $userInfoBd.getState()?.id + '';
        const res = await axios.post(`${defaultPath}add_toy_to_user`,{user_id,code_id});

        return res.data;
    },
}